import i18n from '../../plugins/i18n'
import { EQ, GT, GTE, LT, LTE, NEQ } from '@/composables/filters/operators'
import {
  getAvailableProperties,
  getDataType,
  getOperators,
  getOptions,
  getOptionTitle,
  getPropertyTitle,
  getSortableProperties,
} from '@/composables/filters/filterHelpers'
const { t } = i18n.global

const properties = {
  published: {
    title: t('filters.reports.properties.published.title'),
    operators: [EQ, NEQ],
    dataType: 'boolean',
  },
  minimalReport: {
    title: t('filters.reports.properties.minimalReport.title'),
    operators: [EQ, NEQ],
    dataType: 'boolean',
  },
  createdAt: {
    title: t('filters.reports.properties.createdAt.title'),
    operators: [EQ, NEQ, GT, GTE, LT, LTE],
    dataType: 'timestamp',
  },
  startTimestamp: {
    title: t('filters.reports.properties.startTimestamp.title'),
    operators: [EQ, NEQ, GT, GTE, LT, LTE],
    dataType: 'timestamp',
  },
  endTimestamp: {
    title: t('filters.reports.properties.endTimestamp.title'),
    operators: [EQ, NEQ, GT, GTE, LT, LTE],
    dataType: 'timestamp',
  },
}

const sortableProperties = ['createdAt', 'startTimestamp', 'endTimestamp']

export default {
  getOptionTitle: (propertyId, optionId) => getOptionTitle(properties, propertyId, optionId),
  getPropertyTitle: propertyId => getPropertyTitle(properties, propertyId),
  getAvailableProperties: () => getAvailableProperties(properties),
  getOperators: propertyId => getOperators(properties, propertyId),
  getDataType: propertyId => getDataType(properties, propertyId),
  getOptions: propertyId => getOptions(properties, propertyId),
  getSortableProperties: () => getSortableProperties(sortableProperties, properties),
}
